<div class="flex flex-col h-screen">

  <div class="px-6 pt-4 pb-2">
    <div class="flex justify-between items-center">
      <div>
        <h1 class="text-2xl font-bold text-gray-800">Clientes Pendentes de Aprovação</h1>
        <p class="text-sm text-gray-500">Gerencie os cadastros de clientes pendentes</p>
      </div>
    </div>
  </div>

  <div class="px-6 py-4 bg-white shadow shrink-0 z-10">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <input 
        type="text" 
        (input)="onSearchChange()" 
        [(ngModel)]="searchTerm" 
        placeholder="Buscar por nome ou CPF..." 
        class="border border-gray-300 rounded px-3 py-2 text-sm" 
      />
      <div class="text-sm text-gray-600 flex items-center">
        {{ totalRecords }} registro(s) encontrado(s)
      </div>
    </div>
  </div>

  <div class="px-6 py-2">
  </div>

  <div class="flex-1 overflow-y-auto px-6 py-4 bg-gray-50 md:mb-32">
    <div class="bg-white shadow rounded overflow-x-auto">
      <p-table 
        [value]="customers" 
        [paginator]="false"
        [loading]="loading"
        styleClass="p-datatable-sm"
        [rowHover]="true"
        [stripedRows]="true"
        stripedRowsClass="bg-orange-50"
        [showCurrentPageReport]="false"
        responsiveLayout="scroll"
        class="min-w-full text-sm">
        <ng-template pTemplate="header">
          <tr class="bg-gray-100">
            <th class="text-left px-6 py-3">Data de Cadastro</th>
            <th class="text-left px-6 py-3">Funcionário</th>
            <th class="text-left px-6 py-3">Nome</th>
            <th class="text-left px-6 py-3">CPF</th>
            <th class="text-left px-6 py-3">Ações</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-customer let-i="rowIndex">
          <tr [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'">
            <td class="px-6 py-2">{{ customer.createdAt | date: 'dd/MM/yyyy HH:mm' }}</td>
            <td class="px-6 py-2 font-semibold text-gray-900">{{ customer.employee }}</td>
            <td class="px-6 py-2 font-semibold text-gray-900">{{ customer.customerFullName }}</td>
            <td class="px-6 py-2 font-mono">{{ customer.customerCpf }}</td>
            <td class="px-6 py-2">
              <div class="flex space-x-2">
                <p-button
                  pTooltip="Aprovar"
                  icon="pi pi-check"
                  text
                  severity="success"
                  (click)="approve(customer)">
                </p-button>
                <p-button
                  pTooltip="Rejeitar"
                  icon="pi pi-times"
                  text
                  severity="danger"
                  (click)="reject(customer)">
                </p-button>
                <p-button
                  pTooltip="Visualizar"
                  icon="pi pi-eye"
                  text
                  severity="secondary"
                  (click)="view(customer)">
                </p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5" class="text-center py-8 text-gray-500">
              Nenhum registro encontrado
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- Paginator -->
    <div class="flex justify-center py-4">
      <p-paginator
        [first]="first"
        [rows]="rows"
        [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"
        [showCurrentPageReport]="true"
        [showPageLinks]="true"
        [showFirstLastIcon]="true"
        styleClass="custom-paginator">
      </p-paginator>
    </div>
  </div>

</div>

<!-- Modal de Visualização e Comparação -->
<app-view-customer-pending-approval-modal
  [(visible)]="showViewModal"
  [customerPendingApproval]="selectedCustomer"
  (visibleChange)="onModalClosed()"
  (approved)="onApproved()"
  (rejected)="onRejected()">
</app-view-customer-pending-approval-modal>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>


